import styled from 'styled-components';

export const ModalActions = styled.div`
  display: flex;
  justify-content: center;
  .btn {
    color: white;
  }
`;
